export enum ViewTableStyle {
    LIST = 0,
    GRID = 1,
}
